
import { Avatar, Box, Button, Checkbox, Container, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Link, Modal, Radio, Stack, Tab, Tabs, TextField, TextareaAutosize, Typography } from '@mui/material'

import React, { useEffect } from 'react'
import { useState } from 'react';
import { RxCross1 } from "react-icons/rx";
import CustomButtoncolor from '../custom-button/customColorButton';
// import { sendReminder } from '../../store/crm/pos';
import { sendReminder } from '../../store/crm/pos';
import { useDispatch, useSelector } from 'react-redux';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import {PlayArrow} from "@mui/icons-material";
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { toast } from 'react-hot-toast';
import { Label, Margin } from '@mui/icons-material';
import { setEmail, setSms } from '../../store/crm/crm';
import { useFormik } from 'formik';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import { getAppointmentNotes } from '../../store/crm/appointment/notes';
import { useParams } from 'react-router';
import {scrollCSS} from "../../App";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AddNotesModal from './AddNotesModal';
import { getCrmNotes } from '../../store/crm/crm/crm-details';
import { getAppointmentDetails } from '../../store/crm/appointment';
import AppointmentDetailsmodal from './AppointmentDetailsmodal';
import Waveloading from '../../pages/loading/Waveloading';
import AddAttachment from '../../pages/crm/appointment/appointment-details/appointment-attachment/addAttachment';
import AddAttachmentModal from './AddAttachmentModal';
import { addAppointmentMileStone, deleteAppointmentAttachment, deleteAppointmentGallery, deleteAppointmentGalleryFile, getAppointmentAttachments, getAppointmentGallery } from '../../store/crm/appointment/attachment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import {MySwal, successConfirmation} from "../../services/utills";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';

import ViewStreamIcon from '@mui/icons-material/ViewStream';
import CSV from '../../assets/images/csv.png'
import PDF from '../../assets/images/pdf.png'
import word from '../../assets/images/word.png'
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import moment from 'moment/moment';
import CustomModal from './customModal';
import { mySwalButton, mySwalButtonCancel, mySwalButtonYes } from '../card-appointment/CardAppointment';
import { FormLinkData, getAllSubmittedTreatmentForms } from '../../store/user/chart-form';
import LinkModal from '../card-appointment/LinkModal';
import Customcolorbtn from '../custom-button/customeColorCalender';
const style = { 
    position: 'absolute',
    top: '50%',  
    left: '50%',
    height:'90vh',
    transform: 'translate(-50%, -50%)',
    width: {   
        xs: '90%',   // Extra small devices
        sm: '90%',   // Small devices
        md: '80%',   // Medium devices
        lg: '80%',   // Large devices
        xl: '80%',   // Extra large devices
    },
    bgcolor: 'background.paper',
    p: '7px 12px',
    borderRadius: '15px',
    gap: "5px",
    boxShadow: (theme) => theme.shadows[5], // Optional: add shadow for better visibility
};

  const wrapper={
    alignItems:"center", 
  }
  const heading={
    fontSize:"24px", 
    fontFamily:'helvetica-lt-std-roman',
    fontWeight:'500',
    textAlign:"center",
    width:'100%'

  }
 
  export const inputStyle = {
    background: "#EDF2F7",
    borderRadius: '4px',
    ".MuiOutlinedInput-notchedOutline": {
        borderWidth: "0!important"
    },
    ".MuiInputBase-input": {
        borderColor: " #EDF2F7",
        height: "19px",
        minHeight: 'unset',
        "&:focus": {
            borderColor: "#EDF2F7",
            outline: "none",
            "input": {
                height: '19px'
            }
        },
        "&:hover": {
            borderColor: "#EDF2F7",
            outline: "none",
        }
    }
}
export const btnwrappe ={
  marginTop:"5px",
  display:"flex",
  justifyContent:"flex-end",
  gap:"10px"
  
}
 export const textareaStyle = {

  height: '220px',
  border:"none",
    background: "#EDF2F7",
    borderRadius: '4px',
    outline:"none",
      "&:focus": {
        borderColor: "#EDF2F7",
        outline: "none",
      },
      "&:hover": {
        borderColor: "#EDF2F7",
        outline: "none",
    }
    
};


const CalenderNoteModal= ({customer_id,appointment_id,name,data,isbtn}) => {
      const dispatch = useDispatch()
      const [open, setOpen] = useState(false)   
      const [loading , setLoading]=useState(false)
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [expandedCards, setExpandedCards] = useState({});

          const [selectedLinkUrl, setSelectedLinkUrl] = useState(null);
          const openModal = (linkUrl) => {
            setSelectedLinkUrl(linkUrl);
            setIsModalOpen(true);  
          }
          
          const closeModal = () => {  
            setSelectedLinkUrl(null);
            setIsModalOpen(false);
          }  
      const handleClose = () => setOpen(false)
      const [message, setMessage] = useState("") 
      const [subject, setSubject] = useState("") 
         const [search, setSearch] =useState('')
      const [active, setActive] = useState(0) 
      const crmDetailsStore = useSelector(state => state?.crmDetailsStore)
      const {notes=[]} = crmDetailsStore 
      const [attachmentDetails, setAttachmentDetails] = useState(null)
      const [onHover, setOnHover] = useState(false)
          const [allSubmittedForm, setAllSubmittedForm] = useState([])
              const [rescheduleModal, setRescheduleModal] = useState(false) 
      // const [loading, setLoading] = useState(false)
      const [activeView, setActiveView] = useState( "card")
      const [showFullDescription, setShowFullDescription] = useState(false);
      const [checkedAttachments, setCheckedAttachments] = useState([]);
  const [modalImage,setModalImage]=useState(null)
      const crmAppointmentAttachmentStore = useSelector(state => state?.crmAppointmentAttachmentStore)
      const {galleryList = []} = crmAppointmentAttachmentStore 
      const [appointmentDetails, setAppointmentDetail] = useState(null)


          

    // const {appointment_id} = useParams()
    const crmAppointmentStore = useSelector( 
        (state) => state?.crmAppointmentStore
      ); 
      const { appointmentDetail = [] } = crmAppointmentStore; 
      useEffect(()=>{
          (async ()=>{
              await dispatch(getAppointmentAttachments(appointment_id))
          })()
      },[]) 
      const handleOpen = () => {
        setOpen(true); 
        if (!open) { 
            setLoading(true);
            dispatch(getCrmNotes(customer_id))
                .finally(() => setLoading(false));
        } 
    };
    const customerId = data?.customer_id || data?.customer?.id   
  const handleSubmitted = async () => {
          setLoading(true)
        setActive(3)
        let {payload}= await dispatch(getAllSubmittedTreatmentForms({id: customerId, provider_id: data?.provider?.id}))
        setLoading(false);
        setAllSubmittedForm(payload)
 
    }   
      useEffect(() => {
        // Ensuring the modal is open before making the API call
        if (open) { 
            setLoading(true);
         dispatch(getCrmNotes(customer_id))
        .finally(() => setLoading(false));
        }
    }, [open, dispatch]);
   

    const handleChange = (event, newValue) => {   
        setActive(newValue)  
    }  
     //console.log("notes",notes,)
     const handleAppointmentDetail = async (id) => {

        let { payload } = await dispatch(getAppointmentDetails(id))

        if (payload?.id) {
            setAppointmentDetail(payload)
        } else {
            setAppointmentDetail(null)
        }
    }
    useEffect(() => {
        (async () => {
            await dispatch(getAppointmentGallery(appointment_id))   
        })()
    }, [])  


    const handleDelete = async (id) => {

        let confirm = await MySwal.fire({
            // icon: 'question',
            title: 'Are you sure? ',
            showConfirmButton: false,
            html: <Box >
                 <Stack
            sx={{
                width: '100%', // ensures the stack takes up full width
                justifyContent:"center"
            }}
           direction={{ xs: 'column', lg: 'row',sm:"row" }} // column for mobile and row for large screens
            spacing={2} // adds spacing between buttons
        >
                                         <Button
                                           sx={{ 
                                            backgroundColor: "#56ccf2",
                                            color: "#fff",
                                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                                            border: "1px solid rgb(15, 163, 232)",
                                            borderRadius: '10px',
                                            fontSize: '16px',
                                            // px: '20px',
                                            // mx: '10px',
                                            "&:hover": {
                                              backgroundColor: "#56ccf2",
                                              border: "1px solid rgb(21, 172, 232)",
                                            },}}
                                           onClick={() => MySwal.clickConfirm()}
                                         >
                                            Yes, Delete
                                         </Button>
                                         <Button sx={{  backgroundColor: "#f44336",
                            color: "#fff",
                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                            border: "1px solid #f44336",
                            borderRadius: '10px',
                            fontSize: '16px',
                            // px: '20px',
                            // mx: '10px',
                            "&:hover": {
                              backgroundColor: "#d32f2f",
                              border: "1px solid #d32f2f",
                            },
  }} onClick={() => MySwal.close()}>
                                         NO
                                         </Button>
                                  </Stack>
               
            </Box>
        })
        if (!!confirm?.isConfirmed) {
            setLoading(true)
            let res = await dispatch(deleteAppointmentGallery({id: id, booking_id: appointment_id}))
           await   dispatch(getCrmNotes(customer_id))
            if (res?.payload?.success === "true") {
             
                toast.success('Gallery Deleted Successfully')
            }
            setLoading(false)  
        } 
    }
    const handleDeleteFile = async (id) => {

        let confirm = await MySwal.fire({
            // icon: 'question',
            title: 'Are you sure? ',
            showConfirmButton: false,
            html: <Box >
                 <Stack
            sx={{
                width: '100%', // ensures the stack takes up full width
                justifyContent:"center"
            }}
          direction={{ xs: 'column', lg: 'row',sm:"row" }} // column for mobile and row for large screens
            spacing={2} // adds spacing between buttons
        >
                                         <Button
                                           sx={{ 
                                            backgroundColor: "#56ccf2",
                                            color: "#fff",
                                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                                            border: "1px solid rgb(15, 163, 232)",
                                            borderRadius: '10px',
                                            fontSize: '16px',
                                            // px: '20px',
                                            // mx: '10px',
                                            "&:hover": {
                                              backgroundColor: "#56ccf2",
                                              border: "1px solid rgb(21, 172, 232)",
                                            },}}
                                           onClick={() => MySwal.clickConfirm()}
                                         >
                                            Yes, Delete
                                         </Button>
                                         <Button 
                          sx={{   backgroundColor: "#f44336",
                            color: "#fff",
                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                            border: "1px solid #f44336",
                            borderRadius: '10px',
                            fontSize: '16px',
                            // px: '20px',
                            // mx: '10px',
                            "&:hover": {
                              backgroundColor: "#d32f2f",
                              border: "1px solid #d32f2f",
                            },
 }} onClick={() => MySwal.close()}>
                                         NO
                                         </Button>
                                       </Stack>
               
            </Box>
        })
        if (!!confirm?.isConfirmed) {
            setLoading(true)
            let res = await dispatch(deleteAppointmentGalleryFile({id: id, booking_id: appointment_id}))
           await dispatch(getCrmNotes(customer_id))
            if (res?.payload?.success === "true") {
               
                toast.success('Gallery File Deleted Successfully')
            }
            setLoading(false)
        }
    }
    const handleMoveMilestone = async (id) => {

        let confirm = await MySwal.fire({
            icon: 'question',
            title: 'Confirmation',
            showConfirmButton: false,
            html: <Box sx={{mb: 4}}>
                <Typography sx={{}}>
                    Are you sure? you want to add  this gallery to milestone?
                </Typography>
                <Box sx={{mt: 3,}}>
                    <Button
                        sx={{
                            backgroundColor: "#fff",
                            minWidth: "max-content",
                            border: "1px solid #666666",
                            borderRadius: '10px',
                            fontSize: '16px',
                            px: '20px',
                            mx: '10px',
                            color: "#666666",
                            "&:hover": {  
                                backgroundColor: "#fff",
                                border: "1px solid #666666",
                            },
                        }}  
                        onClick={() => MySwal.clickConfirm()}
                    >
                        Yes,Add It. 
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#fff",
                            minWidth: "max-content",
                            border: "1px solid #666666",
                            borderRadius: '10px',
                            px: '10px',
                            mx: '10px',
                            fontSize: '16px',
                            color: "#666666",
                            "&:hover": {
                                backgroundColor: "#fff",
                                border: "1px solid #666666",
                            },
                        }}
                        onClick={() => MySwal.close()}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        })
        if (!!confirm?.isConfirmed) {
            setLoading(true)
            let res = await dispatch(addAppointmentMileStone({
                id: id,
                booking_id: appointment_id
            }))
            if (res?.payload?.success === "true") {
                toast.success('Image Added Into Milestone Successfully')
            }
            setLoading(false)
        }
    }
    const handleCheckboxToggle = async (id) => {
        if (checkedAttachments.includes(id)) {
            setCheckedAttachments(checkedAttachments.filter(id => id !== id));
        } else {
            setCheckedAttachments([...checkedAttachments, id]);
        }

        try {
            let confirm = await MySwal.fire({
                // icon: 'question', 
                title: 'Add Milestone ?',
                showConfirmButton: false,
                html: <Box sx={{}}>
                    {/* <Typography sx={{}}>
                        Are you sure? you want to add  this gallery to milestone?
                    </Typography> */}
                     <Stack
            sx={{
                width: '100%', // ensures the stack takes up full width
                justifyContent:"center"
            }}
            direction={{ xs: 'column', lg: 'row',sm:"row" }} // column for mobile and row for large screens
            spacing={2} // adds spacing between buttons
        >
                        <Button
                             sx={{ 
                                            backgroundColor: "#56ccf2",
                                            color: "#fff",
                                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                                            border: "1px solid rgb(15, 163, 232)",
                                            borderRadius: '10px',
                                            fontSize: '16px',
                                            // px: '20px',
                                            // mx: '10px',
                                            "&:hover": {
                                              backgroundColor: "#56ccf2",
                                              border: "1px solid rgb(21, 172, 232)",
                                            },}}
                            onClick={() => MySwal.clickConfirm()}
                        >
                            YES,ADD 
                        </Button>
                        <Button
                            sx={{   backgroundColor: "#f44336",
                            color: "#fff",
                            minWidth: {sm:'150px', xs:'59%'},   // fixed width
                            border: "1px solid #f44336",
                            borderRadius: '10px',
                            fontSize: '16px',
                            // px: '20px',
                            // mx: '10px',
                            "&:hover": {
                              backgroundColor: "#d32f2f",
                              border: "1px solid #d32f2f",
                            },
 }}
                            onClick={() => MySwal.close()}
                        >
                            NO
                        </Button>
                   </Stack>
                </Box>
            })
            if (!!confirm?.isConfirmed) {
                setLoading(true)
                let res = await dispatch(addAppointmentMileStone({
                    id: id,
                    booking_id: appointment_id  
                }))
                if (res?.payload?.success === "true") {
                  toast.success('Image Added Into Milestone Successfully')
                }
                setLoading(false)
            }
        } catch (error) { 
        }
    };
    const handleSelectedGallery = (attachment) => {
 
        if (attachmentDetails?.id){
            setAttachmentDetails(attachmentDetails?.id === attachment?.id  ? null : attachment)
            // setActiveView("card")
        }else {
            setAttachmentDetails(attachment)
            setActiveView("list")
        }
    } 
   
    const filteredSubmitForm= allSubmittedForm?.consent?.filter(form =>
      form.name.toLowerCase().includes(search.toLowerCase())    
    ) 
      const handleRowClick = async (userid,formid) => {
            let confirm = await MySwal.fire({
                                     // icon: 'question',
                                     title:" Email Send ?",
                                     showConfirmButton: false, 
                                     customClass: {
                                         icon: 'custom-icon-size',
                                         popup: 'custom-popup-shadow', 
                                         closeButton: 'custom-close-button', 
                                       },
                                     showCloseButton: true,
                                     // showCancelButton: true,
                                     html: ( 
                                       <Box>
                                          {/* <Typography sx={{}}>
                                             Are you sure? you want to change appointment status to {label}.
                                         </Typography> */}
                                         <Box sx={{
                                           mt: 3,
                                           display: "flex",
                                           flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
                                           gap: "12px",
                                           justifyContent: "center"
                                         }}>
                                           <Button
                                             sx={{
                                               backgroundColor: "#56ccf2",
                                               color: "#fff",
                                               minWidth: "150px",   // fixed width
                                               border: "1px solid rgb(15, 163, 232)",
                                               borderRadius: '10px',
                                               fontSize: '16px',
                                               px: '20px',
                                               mx: '10px',
                                               "&:hover": {  
                                                 backgroundColor: "#56ccf2",
                                                 border: "1px solid rgb(21, 172, 232)",
                                               },
                                             }}
                                             onClick={() => MySwal.clickConfirm()}
                                           >
                                             YES                        
                                              </Button>
                                           <Button
                                             sx={{
                                               backgroundColor: "#f44336",
                                               color: "#fff",
                                               minWidth: "150px",   // fixed width
                                               border: "1px solid #f44336",
                                               borderRadius: '10px',
                                               fontSize: '16px',
                                               px: '20px',
                                               mx: '10px',
                                               "&:hover": {
                                                 backgroundColor: "#d32f2f",
                                                 border: "1px solid #d32f2f",
                                               },
                                             }}
                                             onClick={() => MySwal.close()}
                                           >
                                             NO 
                                           </Button>
                                         </Box>
                                       </Box>
                                     )
                                   });
            if (!!confirm?.isConfirmed) {
                const payload = {
       
                    user_id: userid,
                    form_id: formid 
                  };
              
                setLoading(true);
              dispatch(FormLinkData(payload));
              setLoading(false);
               
                }else {
                    setRescheduleModal(true)
                }
     }
     const toggleCardExpansion = (noteId) => {
      setExpandedCards(prev => ({
        ...prev,
        [noteId]: !prev[noteId]
      }));
    };
    
    //console.log ("data cominhg",galleryList)
    return (
      <>
        <Customcolorbtn
        handleClick={handleOpen}
         mainColor={"#be5268"}
         size="md"                    
         val='Patient Records'
         style={{ width:'100%', padding:'12px 5px !important' }}  
        icon={isbtn ? <PlaylistAddCheckCircleIcon /> : null}       

      />
   <Modal  
    style={{}}
    open={open}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
>
    <Container maxWidth="xl">
        {loading ? <Waveloading fullSize /> : ''}
        <Box sx={style}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <IconButton
                    size="small"
                    onClick={() => setOpen(false)}
                    style={{ color: "red" ,marginBottom:"10px"}}
                >
                    <CloseRoundedIcon style={{ fontSize: '2rem' }} />
                </IconButton>
            </Box>
            <Box sx={{ background: "#fff", minHeight: '100px', borderRadius: "8px", p: { sm: '10px', xs: '8px' } }}>
     <Grid container spacing={2} sx={{ alignItems:'center' }}>
      <Box sx={{ display:'flex',justifyContent:{sm:'space-between', xs:'space-between', width:'100%'}, alignItems:'center', flexWrap:'wrap' }}>
              <Grid lg={6}>
          <Typography sx={{ fontSize:{sm:'1.5rem', xs:'1.25rem'}, fontWeight:'bold',pl:{sm:2, xs:'16px'}, fontFamily:'helvetica-lt-std-roman'}}>
          Patient Records
          </Typography>
        </Grid>
        <Grid lg={6} sx={{ textAlign:{sm:'end', xs:'start'}, mt:{sm:0, xs:1} ,pl:{sm:2, xs:0.5},pr:{md:'26px',sm:0, xs:0}}}>
          <Typography sx={{ fontSize:'1rem',color:'rgb(107 114 128)',pl:{sm:2, xs:0.5} }}>Patient: <span style={{ color:'#000' }}>{name}</span> </Typography>
          </Grid>
      </Box>

                    <Grid item xl={6} lg={7} md={12}  xs={12}>
                        <Box sx={{ 
                            width: '100%',
                        }}>
                            <Tabs
                                value={active}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                sx={{
                                    ".MuiTabs-indicator": {
                                        background: '#000000',
                                        display:'none'
                                    },
                                    ".Mui-selected": {
                                        fontWeight: '600',
                                        color: '#000!important',
                                        background:'#fff',
                                        borderRadius:'7px',
                                        margin:'7px'
                                    },
                                    '@media (max-width: 600px)': {
                                        width: 'auto',
                                        display: 'flex',
                                        '& .MuiTabs-scrollButtons': {
                                        display: 'flex',
                                        width:'18px'
                                      },
                                       '& .MuiTabs-scroller': {
                                        background:'#f6f7f9',
                                       }
                                    },
                                        '@media (min-width: 601px)': {
      // Hide scroll buttons on larger screens
      '& .MuiTabs-scrollButtons': {
        display: 'none',
      },
    },
                                    '& .MuiTabs-scroller': {
                                        display: 'flex',
                                    borderRadius:'5px',
                                    },
                                    '& .MuiTabs-flexContainer': {
                                    background:'#f6f7f9',
                                    borderRadius:'5px',
                                    },

                                    
                                }}
                            >
                                <Tab
                                    sx={{
                                        fontFamily: active === 0 ? "helvetica-lt-std-bold" : "helvetica-lt-std-roman",
                                        fontSize: '0.875rem',
                                        color: '#000',
                                        textTransform: "capitalize",

                                    }}
                                    label={"Medical/Staff Notes "}
                                    key={0}
                                />
                                <Tab
                                    sx={{
                                        fontFamily: active === 1 ? "helvetica-lt-std-bold" : "helvetica-lt-std-roman",
                                        fontSize: '0.875rem',
                                        color: '#000',
                                        textTransform: "capitalize",
                                    }}
                                    label={"Customer Notes"}
                                    key={1} />
                                <Tab
                                    sx={{
                                        fontFamily: active === 2 ? "helvetica-lt-std-bold" : "helvetica-lt-std-roman",
                                        fontSize: '0.875rem',
                                        color: '#000',
                                        textTransform: "capitalize",
                                    }}
                                    label={"Photos"}
                                    key={2} />
                                     <Tab
                                       onClick={handleSubmitted}
                                    sx={{
                                        fontFamily: active === 3 ? "helvetica-lt-std-bold" : "helvetica-lt-std-roman",
                                        fontSize: '0.875rem',
                                        color: '#000', 
                                        textTransform: "capitalize",
                                    }}
                                    label={"Submited Form"}
                                    key={3} />
                            </Tabs>
                        </Box>
                    </Grid>
                    <Grid item xl={6} lg={5} md={12} xs={12} sx={{ display: 'flex', flexWrap:'wrap', justifyContent: { lg: 'flex-end', xs: 'start', }, pr: { xl:3,lg: 1, xs: 0 } }}>
                        <AddNotesModal appointmentDetails={appointmentDetail} wid={"100%"}/>
                        <Box sx={{ marginLeft: {sm:'10px', xs:0}, mt:{sm:0, xs:2},width:{sm:'auto', xs:'100%'} }}>
                            <AddAttachmentModal appointmentDetails={appointmentDetail} sx={{ p: '0 !important' }} wid={"100%"}/>
                        </Box>
                    </Grid>
                </Grid>  

                <Box
                    sx={{
                        p: '4px 0 24px 0',
                        overflowY: 'auto',
                        maxHeight: {xl:'65vh',lg:'61vh',md:'60vh',sm:'57vh',xs:'50vh'},
                            '@media (max-height: 685px)': {
                                maxHeight: '42vh !important', // For screens smaller than 670px
    },
'@media (min-height: 900px) and (max-height: 1400px)' :{
 maxHeight: '65vh !important', 
},
'@media (min-width: 400px) and (max-width: 450px) and (max-height: 1100px)' :{
 maxHeight: '55vh !important', 
}
   
                    }}
                >
                    {active === 0 && <Box>
        <Typography sx={{ fontSize:{sm:'1.25rem', xs:'1.25rem'}, fontWeight:'bold',pl:{sm:0, xs:0.5}, fontFamily:'helvetica-lt-std-roman', color:'rgb(55 65 81)', mt:3, mb:2}}>
          Medical/Staff
          </Typography>
                        {notes?.data?.Medical?.length > 0 ?   
                            notes?.data.Medical.map((note, index) => {
                                const formattedDate = new Date(note?.date);
                                const dateOnly = formattedDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  });
                              
                                  const timeOnly = formattedDate.toLocaleTimeString('en-US', {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                  });
return(
    <Box>
    <Grid container sx={{}} spacing={2}>

<Grid item lg={12} xs={12}>
<Box
sx={{
boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
px: 2,
py: 2,
borderLeft: "5px solid rgb(59 130 246) !important",
border:'1px solid #e5e7eb',
borderRadius:'8px',
mx:{sm:0, xs:0},
mt:1
}}
>
<Typography
  sx={{
    fontSize: "1rem",
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    fontWeight: '500',
    whiteSpace: "normal",
    overflowWrap: "break-word",
  }}
>
  {note?.type === "Gallery" ? (
    <>
      {(expandedCards[note.id]
        ? note?.appointment_attachment_files
        : note?.appointment_attachment_files?.slice(0, 1)
      )?.map((fileObj, idx) => {
        const file = fileObj?.file || '';
        const fullFileUrl = `https://api.3dlifestyle.ca/images/appointment/file/${file}`;
        const isImageFile = /\.(jpeg|jpg|gif|png|jfif|webp|bmp|svg)$/i.test(file);

        return (
          <div
            key={idx}
            style={{
              cursor: isImageFile ? 'pointer' : 'default',
              color: isImageFile ? 'blue' : 'inherit',
              textDecoration: isImageFile ? 'underline' : 'none',
              marginBottom: '6px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            onClick={() => {
              if (isImageFile) {
                setModalImage(fullFileUrl);
              }
            }}
          >
            {file.split('/').pop()}
          </div>
        );
      })}

      {!expandedCards[note.id] && note?.appointment_attachment_files?.length > 1 && (
        <div style={{ marginBottom: '6px' }}>...&nbsp;</div>
      )}

      {note?.appointment_attachment_files?.length > 1 && (
        <div
          style={{
            cursor: 'pointer',
            color: 'rgb(47, 128, 237)',
            textDecoration: 'underline',
            display: 'inline-block',
          }}
          onClick={() => toggleCardExpansion(note.id)}
        >
          {expandedCards[note.id] ? 'show less' : 'show more'}
        </div>
      )}
    </>
  ) : (
    <>
      {note?.description
        ?.split(' ')
        .slice(0, expandedCards[note.id] ? undefined : 25)
        .map((word, idx) => (
          <span key={idx}>{word}&nbsp;</span>
        ))}

      {note?.description?.split(' ').length > 25 && (
        <span
          style={{
            cursor: 'pointer',
            color: 'rgb(47, 128, 237)',
            textDecoration: 'underline',
          }}
          onClick={() => toggleCardExpansion(note.id)}
        >
          {expandedCards[note.id] ? 'show less' : 'show more'}
        </span>
      )}
    </>
  )}
</Typography>


{/* <Typography
  sx={{
    fontSize: "1rem",
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    fontWeight: '500',
    // whiteSpace: 'pre-wrap',     
    // wordBreak: 'break-word', 
     whiteSpace: "normal", // Keep normal wrapping
    overflowWrap: "break-word",
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    padding: '0 8px'
    // whiteSpace: "normal", 
    // overflowWrap: "break-word",  // Breaks long words if needed  

  }}
>
{(showFullDescription ? note?.description : note?.description?.slice(0, 125))
    ?.split(' ')
    .map((word, idx) => {
      // Improved regex for image files (case insensitive)
      const isImageFile = /\.(jpeg|jpg|gif|png|jfif)$/i.test(word);

      return (
        <span
          key={idx}
          style={{
            cursor: isImageFile ? 'pointer' : 'default',
            color: isImageFile ? 'blue' : 'inherit',
            textDecoration: isImageFile ? 'underline' : 'none',
          }}
          onClick={() => {
            if (isImageFile) {
              const imageUrl = note?.attachments?.file;
              //console.log("Image URL:", imageUrl);
              setModalImage(imageUrl);
            }
          }}
        >
          {word}&nbsp;
        </span>
      );
    })
  }

  {note?.description?.split(' ').length > 25 && (
    <span
      style={{
        cursor: 'pointer',
        color: 'black',
        textDecoration: 'underline',
        color:'rgb(47, 128, 237)'
      }}
      onClick={() => setShowFullDescription(!showFullDescription)}
    >
      {showFullDescription ? 'show less' : 'show more'}
    </span>
  )}
</Typography> */}




<Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
  <Box sx={{
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'flex-start', sm: 'center' },
  flex: 1
}}>
  <Box sx={{ display:'flex',alignItems:'center',gap:"10px" }}>

<span style={{ color:'rgb(107 114 128 )', marginLeft:'10px', marginTop:'5px', fontSize:'.75rem'}}>Notes Type</span> 
<Typography
sx={{
fontSize:'.75rem',
mt: 1,
backgroundColor:'rgb(243 244 246)',
borderRadius:'15px',
textAlign:'center',
padding:'2px 10px',

}}
>
{note?.type}

</Typography>
</Box>
  <Box sx={{ display:'flex',alignItems:'center', gap:"10px"}}>

<span style={{ color:'rgb(107 114 128 )', marginLeft:'10px', marginTop:'5px', fontSize:'.75rem'}}>Staff Name</span> 
<Typography
sx={{
fontSize:'.75rem',
mt: 1,
backgroundColor:'rgb(243 244 246)',
borderRadius:'15px',
textAlign:'center', 
padding:'2px 10px',

}}
>
{note?.staff?.name || "Not assigned"}


</Typography>
</Box>
  </Box>






{/* <Box sx={{ minWidth:'60px', ml:'3px' }}>
<BorderColorIcon sx={{color:'rgb(156 163 175)', mr:1, fontSize:'18px'}}/>
<DeleteIcon sx={{color:'rgb(156 163 175)', mr:1, fontSize:'18px'}} />
</Box> */}
</Box>

<Divider sx={{color:'rgb(156 163 175)', mt:2}}/>
<Box sx={{ display:'flex', justifyContent:'space-between' , mt:1, alignItems:'center', flexWrap:'wrap'}}>
<Box sx={{ display:'flex' }}>
<Typography
sx={{
color:'rgb(156 163 175)', fontSize:'0.9rem',
mt: {sm:0.5, xs:0.5},
marginRight:'10px',
}}
>
<CalendarMonthIcon sx={{ fontSize:'18px', marginTop:'-3px' }}/>  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px',fontSize:'0.9rem'}}> {dateOnly}   {" "}</span> 
</Typography>
<Typography
sx={{
color:'rgb(156 163 175)', fontSize:'0.9rem',
mt: '4px',
marginLeft:'5px',
}}
>
<AccessTimeIcon sx={{ fontSize:'18px' }} />  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px', fontSize:'0.9rem'}}>{timeOnly}</span>  
</Typography>


</Box>

{note?.booking_id && (
  <Box>
    <Typography
      variant="body2"
      sx={{
        color: 'rgb(156 163 175)',
        fontSize: '0.9rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      Booking No:
      <span style={{ marginLeft: '5px', fontSize: '0.9rem' }}>
        <AppointmentDetailsmodal booking_id={note.booking_id} />
      </span>
    </Typography>
  </Box>
)}

</Box>  
</Box>
</Grid>

</Grid>
</Box>
)
                          
})
                            : 
                            <Grid container>
                              <Grid item lg={12} sx={{ display:'flex', justifyContent:'center' }}>
                                <Box sx={{ pl:{sm:'10px', xs:'7px'}, }}>None</Box>
                              </Grid>
                            </Grid> 
                            }
                    </Box>
                    }

                    {active === 1 && <Box>
            <Typography sx={{ fontSize:{sm:'1.25rem', xs:'1.25rem'}, fontWeight:'bold',pl:{sm:0, xs:0.5}, fontFamily:'helvetica-lt-std-roman', color:'rgb(55 65 81)', mt:3, mb:2}}>
          Customer Notes
          </Typography>
                        {notes?.customer_appointments_notes?.Customer?.length > 0 ?
                            notes?.customer_appointments_notes?.Customer.map((note, index) => {
                                const formattedDate = new Date(note?.date);
                                const dateOnly = formattedDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  });
                              
                                  const timeOnly = formattedDate.toLocaleTimeString('en-US', {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                  });
                                return(
                                    <Box>
                                    <Grid container sx={{}} spacing={2}>
                                
                                <Grid item lg={12} xs={12}>
                              <Box
                                sx={{
                                borderLeft: "5px solid rgb(59 130 246) !important",
                                border:'1px solid #e5e7eb',
                                px: 2,
                                py: 2,
                                borderRadius:'8px',
                                mx:{sm:0, xs:0},
                                mt:1
                                }}
                                >
                                <Typography
                                sx={{
                                fontSize: " 1rem",
                                lineHeight: 1.6,
                                letterSpacing: "0.0075em",
                                fontWeight:'500'
                                }}
                                >
                                {note?.description.split(' ').map((word, idx) => {
                                const isImageFile = /^[0-9].*\.(jpeg|jpg|gif|png|jfif)$/.test(word); 
                                
                                return (
                                <span  
                                key={idx} 
                                style={{
                                cursor: isImageFile ? 'pointer' : 'default',
                                color: isImageFile ? 'blue' : 'inherit', 
                                textDecoration: isImageFile ? 'underline' : 'none',
                                }} 
                                onClick={() => {
                                if (isImageFile) {
                                const imageUrl = note?.attachments?.file; 
                                //console.log("Image URL:", imageUrl);
                                setModalImage(imageUrl); 
                                }
                                }} 
                                >
                                {word}&nbsp; {/* Add a space here */}
                                </span>
                                );
                                })}
                                </Typography>

                                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                <Box sx={{ display:'flex',alignItems:'center' }}>
                                <Typography
                                sx={{
                                fontSize:'.75rem',
                                mt: 1,
                                backgroundColor:'rgb(243 244 246)',
                                borderRadius:'15px',
                                textAlign:'center',
                                padding:'2px 10px',
                                
                                }}
                                >
                              {note?.type}
                                </Typography>
                                <span style={{ color:'rgb(107 114 128 )', marginLeft:'10px', marginTop:'5px', fontSize:'.75rem'}}>{note?.staff?.name}</span> 
                                </Box>
                                
                                {/* <Box sx={{ minWidth:'60px', ml:'3px' }}>
                                <BorderColorIcon sx={{color:'rgb(156 163 175)', mr:1, fontSize:'18px'}}/>
                                <DeleteIcon sx={{color:'rgb(156 163 175)', mr:1, fontSize:'18px'}} />
                                </Box> */}
                                </Box>
                                <Divider sx={{color:'rgb(156 163 175)', mt:2}}/>
                                <Box sx={{ display:'flex', justifyContent:'space-between' , mt:1, alignItems:'center', flexWrap:'wrap'}}>
                                <Box sx={{ display:'flex' }}>
                                <Typography
                                sx={{
                                color:'rgb(156 163 175)', fontSize:'0.9rem',
                                mt: {sm:0.5, xs:0.5},
                                marginRight:'10px',
                                }}
                                >
                                <CalendarMonthIcon sx={{ fontSize:'18px', marginTop:'-3px' }}/>  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px',fontSize:'0.9rem'}}> {dateOnly}   {" "}</span> 
                                </Typography>
                                <Typography
                                sx={{
color:'rgb(156 163 175)', fontSize:'0.9rem',
mt: '4px',
marginLeft:'5px',
                                }}
                                >
                                <AccessTimeIcon sx={{ fontSize:'18px' }} />  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px', fontSize:'0.9rem'}}>{timeOnly}</span>  
                                </Typography>
                                
                                
                                </Box>
                                
                               {note?.booking_id && (
  <Box>
    <Typography
      variant="body2"
      sx={{
        color: 'rgb(156 163 175)',
        fontSize: '0.9rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      Booking No:
      <span style={{ marginLeft: '5px', fontSize: '0.9rem' }}>
        <AppointmentDetailsmodal booking_id={note.booking_id} />
      </span>
    </Typography>
  </Box>
)}

                                </Box>
                                </Box>
                                </Grid>
                                
                                </Grid>
                                </Box>
                                )
                            })
                            : <Grid container>
                              <Grid item lg={12} sx={{ display:'flex', justifyContent:'center' }}>
                                <Box sx={{ pl:{sm:'10px', xs:'7px'}, }}>None</Box>
                              </Grid>
                            </Grid> 
                        }
                    </Box>}
                    {active ===2 && <Box>
            <Typography sx={{ fontSize:{sm:'1.25rem', xs:'1.25rem'}, fontWeight:'bold',pl:{sm:0, xs:0.5}, fontFamily:'helvetica-lt-std-roman', color:'rgb(55 65 81)', mt:3, mb:2}}>
          Photos
          </Typography>
                     {/* <Typography style={{marginTop:"20px",fontWeight:600,fontFamily: 'helvetica-lt-std-bold'}}>Appointment</Typography> */}
                     <Box
            sx={{
                background: "#fff",
                minHeight: '100px',
                borderRadius: "8px",      
                // p: '24px 24px 50px 24px',                
            }}
        >                   
            <Box
                sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: "center",
                    mb: "32px",
                }}
            >
                <Typography
                    sx={{
                        fontSize: '20px',
                    }}
                >

                </Typography> 
                <Box
                    sx={{
                        display: "flex",
                        gap: '2px',
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        onClick={() => setActiveView("card")}
                    >
                        <DashboardIcon
                            sx={{color: activeView === 'card' ? '#09ABF1' : '#000'}}
                        />
                    </IconButton>
                    <IconButton
                        onClick={() => setActiveView("list")}
                    >
                        <ViewStreamIcon
                            sx={{color: activeView === 'list' ? '#09ABF1' : '#000'}}
                        />
                    </IconButton>
                </Box>
            </Box>

            {/* {loading ? <Waveloading fullSize/> : ""} */}

            {activeView === 'list' &&
                <Grid
                    container
                    sx={{
                        gap: '20px',
                        overflowY: 'auto',
                        maxHeight: '500px',
                        ...scrollCSS,
                    }} 
                >
                    {/* {
                        galleryList?.length > 0 ?
                            galleryList.map((attachment) =>  (
                                <Grid
                                    item
                                    xs={12}
                                    key={attachment?.id}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: 'space-between',
                                            background: '#F2F2F2',
                                            borderRadius: "4px",
                                            cursor:'pointer',
                                        }}
                                        onClick={() => handleSelectedGallery(attachment)}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: 'helvetica-lt-std-bold',
                                                ml: "10px",
                                                textTransform:'capitalize',
                                            }}
                                        >
                                            {attachment?.tag?.tag_name}
                                        </Typography>

                                        <IconButton
                                            onClick={() => handleSelectedGallery(attachment)}
                                        >
                                            {attachmentDetails?.id === attachment?.id ?  <ArrowDropDownIcon/>:<ArrowDropUpIcon/>}

                                        </IconButton>
                                    </Box>
                                    {attachmentDetails?.id === attachment?.id && <Box>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                mt: '16px',
                                                display: "flex",
                                                gap: '16px',
                                                flexWrap:'wrap',
                                            }}
                                        >
                                            {attachment?.files?.length > 0 ?
                                                    attachment?.files.map((file, index) => (
                                                        <Box
                                                            key={index}
                                                            sx={{ position: 'relative'}}
                                                        >
                                             <Checkbox
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px',
                                                        right: '0px',
                                                        zIndex: '2',
                                                        pointer: "cursor",
                                                    }}
                                                    checked={file?.is_milestone === 1 || checkedAttachments.includes(file?.id)}
                                                    onChange={() => handleCheckboxToggle(file?.id)}
                                                />
                                                            <Avatar
                                                                src={file?.file}
                                                                onClick={()=>setModalImage(file?.file)}
                                                                sx={{
                                                                    cursor:'pointer',
                                                                    height: '180px',
                                                                    width: '180px',
                                                                }}
                                                                variant="rounded"
                                                            />
                                                            <Box sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent:'space-between',
                                                                mt: "8px"
                                                            }}>
                                                                <Typography sx={{ mr:'10px' }}>
                                                                    {moment(file?.created_at).format("dddd MMMM D, YYYY")}
                                                                </Typography>
                                                                <IconButton
                                                                       sx={{
                                                                        fontSize: "15px",
                        
                                                                        p: "5px",
                                                                       
                                                                        background: "#EB5757",
                                                                        border: '1px solid #EB5757',
                                                                     
                                                                        
                                                                        "&:hover": {
                                                                            border: '1px solid #EB5757',
                                                                            background: '#fff',
                                                                            "svg": {
                                                                                color: '#EB5757'
                                                                            }
                                                                        } 
                                                                    }}
                                                                    onMouseEnter={() => {
                                                                        setOnHover(true)
                                                                    }}
                                                                    onMouseLeave={() => {
                                                                        setOnHover(false)
                                                                    }}
                                                                    onClick={()=>handleDeleteFile(file?.id)}
                                                                >
                                                                    <DeleteOutlineIcon sx={{color: '#fff', fontSize: '20px'}} />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                    ))
                                                    :
                                                    <Avatar
                                                        sx={{
                                                            height: '100%',
                                                            width: '100%',
                                                        }}
                                                        variant="rounded"
                                                    />
                                            }
                                        </Box>

                                        <Box sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            mt: "8px"
                                        }}>
                                            {moment(attachment?.created_at).format("dddd MMMM D, YYYY")}
                                        </Box>
                                        <Box sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            mt: "16px"
                                        }}>

                                            <Typography
                                                sx={{
                                                    fontFamily: 'helvetica-lt-std-bold',
                                                    background: '#F2F2F2',
                                                    mr: '10px',
                                                    pl: '5px',
                                                    pr: '3px',
                                                }}
                                            >
                                                Comments
                                            </Typography>
                                           <Box>
                                               <Typography
                                                   sx={{
                                                       fontSize: '14px',
                                                   }}
                                               >
                                                   {attachment?.comment}
                                               </Typography>

                                               <Typography
                                                   sx={{
                                                    ml:"50px",
                                                       mt:"10px",
                                                       width:'max-content',
                                                       cursor:'pointer',
                                                       fontSize: '14px',
                                                       background:'#CB3838',
                                                       color:'#fff',
                                                       p:'5px 10px',
                                                       borderRadius:'4px',
                                                   }}
                                                   onClick={()=>handleDelete(attachment?.id)}
                                               >
                                                   Delete
                                               </Typography> 
                                           </Box>
                                        </Box>

                                    </Box>
                                    }
                                </Grid>
                            ))
                            :
                            <Grid xs={12} item>
                                <Typography sx={{textAlign: 'center'}}>None</Typography>
                            </Grid>
                    } */}

<Box>
  <Grid container spacing={2}>
    {galleryList?.length > 0 ? (
      galleryList.map((attachment) => (
        <Grid item xs={12} key={attachment?.id}>
          <Box
            sx={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px",
              px: 2,
              py: 2,
              borderLeft: "5px solid rgb(59 130 246)",
              borderRadius: "8px",
              mt: 1,
            }}
          >
            {/* Attachment Title and Toggle */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
                alignItems: "center",
                cursor:"pointer"
              }}
              onClick={() => handleSelectedGallery(attachment)}
            >
              <Typography sx={{ fontWeight: 600, textTransform: "capitalize" }}>
                 {attachment?.tag?.tag_name || "No Tag Assigned"}
              </Typography>
              <IconButton>
                {attachmentDetails?.id === attachment?.id ? (
                   <ArrowDropDownIcon />
                  
                ) : (
                
                  <ArrowDropUpIcon />
                )}
              </IconButton>
            </Box>

            {/* Expanded View */}
            {attachmentDetails?.id === attachment?.id && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  {attachment?.files?.length > 0 ? (
                    attachment?.files.map((file, index) => (
                      <Grid item key={index}>
                        <Box sx={{ position: "relative" }}>
                          <Checkbox  
                            sx={{
                              position: "absolute",
                              top: 0,  
                              right: 0, 
                              zIndex: 2,
                            }}
                            checked={
                              file?.is_milestone === 1 ||
                              checkedAttachments.includes(file?.id)
                            }
                            onChange={() => handleCheckboxToggle(file?.id)}
                          />
                          <Avatar
                            src={file?.file}
                            onClick={() => setModalImage(file?.file)}
                            sx={{
                              height: "180px",
                              width: "180px",
                              cursor: "pointer",
                            }}
                            variant="rounded"
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mt: 1,
                            }}
                          >
                            <Typography variant="body2">
                              {moment(file?.created_at).format(
                                "dddd MMMM D, YYYY"
                              )}
                            </Typography>
                            <IconButton
                              sx={{
                                background: "#EB5757",
                                border: "1px solid #EB5757",
                                "&:hover": {
                                  background: "#fff",
                                  "svg": { color: "#EB5757" },
                                },
                              }}
                              onClick={() => handleDeleteFile(file?.id)}
                            >
                              <DeleteOutlineIcon
                                sx={{ color: "#fff", fontSize: "20px" }}
                              />
                            </IconButton>
                          </Box>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Typography>No files</Typography>
                    </Grid>
                  )}
                </Grid>

                {/* Created At Date */}
                <Typography
                  sx={{ mt: 2, color: "rgb(107 114 128)", fontSize: "0.9rem" }}
                > 
                  Created At:{" "}
                  {moment(attachment?.created_at).format(
                    "dddd MMMM D, YYYY"
                  )}
                </Typography>

                {/* Comments Section */}
                <Box sx={{ mt: 2 }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "1rem",
                      backgroundColor: "#F2F2F2",
                      px: 1,
                      borderRadius: "4px",
                      display: "inline-block",
                    }}
                  >
                    Comments
                  </Typography>
                  <Typography sx={{ mt: 1, fontSize: "14px" }}>
                    {attachment?.comment}
                  </Typography>
                  <Typography
                    onClick={() => handleDelete(attachment?.id)}
                    sx={{
                      mt: 1,
                      fontSize: "14px",
                      cursor: "pointer",
                      background: "#CB3838",
                      color: "#fff",
                      display: "inline-block",
                      px: 2,
                      py: 1,
                      borderRadius: "4px",
                    }}
                  >
                    Delete
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      ))
    ) : (
      <Grid item xs={12}>
        <Typography sx={{ textAlign: "center" }}>None</Typography>
      </Grid>
    )}
  </Grid>
</Box>


                </Grid>
            }
            {activeView === 'card' &&
                <Grid
                    container
                    sx={{
                        gap: '30px',
                        overflowY: 'auto',
                        maxHeight: '500px',
                        ...scrollCSS,
                    }}
                >
                    {
                       <Grid container spacing={2}>
                       {galleryList?.length > 0 ? (
                         galleryList.map((attachment) => (
                           <Grid item xs={12} key={attachment?.id}  onClick={() => !onHover && handleSelectedGallery(attachment)}>
                             <Box
                               sx={{
                                 boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px",
                                 px: 2,
                                 py: 2,
                                 borderLeft: "5px solid rgb(59 130 246)",
                                 borderRadius: "8px",
                                 mx: { sm: 0, xs: 0 },
                                 mt: 1,
                               }}
                             >
                               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                 <Typography
                                   sx={{
                                     fontSize: "1rem", 
                                     fontWeight: "500",
                                     textTransform: "capitalize",
                                   }}
                                 >
                                   {attachment?.tag?.tag_name || "No Tag Assigned"}
                                 </Typography>
                     
                                 <IconButton
                                   sx={{
                                     fontSize: "15px",
                                     p: "5px",
                                     background: "#EB5757",
                                     border: "1px solid #EB5757",
                                     "&:hover": {
                                       background: "#fff",
                                       "svg": {
                                         color: "#EB5757",
                                       },
                                     }, 
                                   }}
                                   onClick={() => handleDelete(attachment?.id)}
                                 >
                                   <DeleteOutlineIcon sx={{ color: "#fff", fontSize: "20px" }} />
                                 </IconButton>
                               </Box>
                     
                              

<Box sx={{ mt: 2 }}>
  {attachment?.files?.length > 0 ? (
    attachment?.files.map((file, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#f9f9f9',
          border: '1px solid #eee',
          borderRadius: '6px',
          px: 2,
          py: 1,
          mb: 1,
          width: '100%',
          cursor: 'pointer',
        }}
        onClick={() => setModalImage(file?.file)}
      >
        <InsertDriveFileIcon sx={{ color: '#1976d2', mr: 1 }} />
        <Typography
          sx={{
            fontSize: '0.9rem',
            color: '#1976d2',
            textDecoration: 'underline',
            wordBreak: 'break-all',
          }}
        >
          {file?.file.split('/').pop()}
        </Typography>
      </Box>
    ))
  ) : (
    <Typography sx={{ fontSize: '0.9rem', color: 'gray' }}>
      No files available
    </Typography>
  )}
</Box>

                     
                               {attachment?.comment && (
                                <Box sx={{ display:'flex',alignItems:'center' }}>
                                <Typography
                                sx={{
                                fontSize:'1rem',
                                mt: 1,
                                backgroundColor:'rgb(243 244 246)',
                                borderRadius:'15px',
                                textAlign:'center',
                                padding:'2px 10px',
                                
                                }}
                                >
                              Comments
                                </Typography>
                                <span style={{ color:'rgb(107 114 128 )', marginLeft:'10px', marginTop:'5px'}}>{attachment?.comment}</span> 
                                </Box>
                               )}
               
                               <Divider sx={{ mt: 2 }} />
                               <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                 {/* <Typography
                                   sx={{
                                     color: "rgb(156 163 175)",
                                     fontSize: "0.9rem",
                                     display: "flex",
                                     alignItems: "center",
                                   }}
                                 >
                                   <CalendarMonthIcon sx={{ fontSize: "18px", mr: 0.5 }} />
                                   {moment(attachment?.created_at).format("dddd, MMMM D, YYYY")}
                                 </Typography> */}
                                  <Box sx={{ display:'flex' ,alignItems:"center"}}>
                                <Typography
                                sx={{
                                color:'rgb(156 163 175)', fontSize:'0.9rem',
                                mt: {sm:0.5, xs:0.5},
                                marginRight:'10px',
                                }}
                                >
                                <CalendarMonthIcon sx={{ fontSize:'18px', marginTop:'-3px' }}/>  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px',fontSize:'0.9rem'}}> {moment(attachment?.created_at).format("dddd, MMMM D, YYYY")}  {" "}</span> 
                                </Typography>
                                <Typography
                                sx={{
                                color:'rgb(156 163 175)', fontSize:'0.9rem',
                                mt: 1,
                                marginLeft:'5px',
                                }}
                                >
                                <AccessTimeIcon sx={{ fontSize:'18px' }} />  <span style={{ color:'rgb(156 163 175)', marginLeft:'2px', fontSize:'0.9rem'}}>{moment(attachment?.created_at).format("hh:mm A")}</span>  
                                </Typography>
                                
                                
                                </Box>
                                 <Typography
                                   sx={{
                                     color: "rgb(156 163 175)",
                                     fontSize: "0.9rem",
                                     display: "flex",
                                     alignItems: "center",
                                   }}
                                 >
                                   Booking No:{" "}
                                   <span style={{ marginLeft: "5px" }}>
                                     <AppointmentDetailsmodal booking_id={attachment?.booking_id} />
                                   </span>
                                 </Typography>
                               </Box>
                             </Box>
                           </Grid>
                         ))
                       ) : (
                         <Grid item xs={12}>
                           <Typography sx={{ textAlign: "center" }}>None</Typography>
                         </Grid>
                       )}
                     </Grid>
                     
                    }
                </Grid>
            }
              </Box>
              </Box>}

              {active === 3 && <Box>
              <Box>
                                                  <Typography
                                                      sx={{
                                                          my: '25px',
                                                          fontFamily: "helvetica-lt-std-bold",
                                                      }}
                                                  >
                                                     Consent Submitted Form:
                                                  </Typography>
                                                  {
                                                      filteredSubmitForm?.length ?
                                                      filteredSubmitForm?.map((form, index) => (
                                                              <Box
                                                                  sx={{
                                                                      width: '100%',
                                                                      background: '#EDF2F7',
                                                                      p: '5px 10px',
                                                                      borderRadius: '5px',
                                                                      mt: '5px', 
                                                                      mb: '10px',
                                                                      height:'auto',
                                                                      display: 'flex',
                                                                      alignItems: 'center',
                                                                      cursor: 'pointer',
                                                                      justifyContent:'space-between',
                                                                  }}
                                                                  key={index}
                                                                 
                                                                  onClick={() => openModal(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`)}
                                                              >
                                                                  <Box
                                                                      sx={{
                                                                          display: 'flex',
                                                                          alignItems: 'center',
                                                                      }} 
                                                                  >
                                                                      <PlayArrow
                                                                          sx={{
                                                                              fontSize: '1.3rem',
                                                                          }}
                                                                      />
                                                                      <Typography
                                                                          sx={{
                                                                              ml: '10px',
                                                                          }}
                                                                      >
                                                                          {form?.name}
                                                                      </Typography>
                                                                  </Box>
                                                                  <Box
                                                              sx={{
                                                                  display: 'flex',
                                                                  alignItems: 'center',
                                                              }}
                                                          >
                                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <AttachEmailIcon
                                                                  onClick={(e) =>{  e.stopPropagation()
                                                                      handleRowClick(form?.customer_id,form?.treatment_form_id)} }
                                                                      sx={{
                                                                          fontSize: '1.3rem',
                                                                      }}
                                                                  /> 
                                                              </div>
                                                                  {
                                                                      form?.is_submitted &&
                                                                    /*  <CheckCircleOutlineIcon
                                                                          sx={{
                                                                              color: '#27AE60',
                                                                              fontSize: '1.8rem'
                                                                          }}
                                                                      />*/
                                                                      <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold" , ml:"5px"}}>{form?.submitted_time}</Typography>
              
                                                                  }
                                                              </Box>
                                                              </Box>
                                                          )) :
                                                          <Typography
                                                              sx={{
                                                                  fontFamily: "helvetica-lt-std-bold",
                                                                  textAlign: 'center',
                                                                  mt: '24px'
                                                              }}
                                                          >
                                                              Empty.
                                                          </Typography>
                                                  }
                                                  <Typography
                                                      sx={{
                                                          my: '25px',
                                                          fontFamily: "helvetica-lt-std-bold",
                                                      }}
                                                  >
                                                      Customer Service Submitted  Form:
                                                  </Typography>
                                                  {
                                                      allSubmittedForm?.customer_service_form?.length ?
                                                          allSubmittedForm?.customer_service_form?.map((form, index) => (
                                                              <Box
                                                                  sx={{
                                                                      width: '100%',
                                                                      background: '#EDF2F7',
                                                                      p: '5px 10px',
                                                                      borderRadius: '5px',
                                                                      mt: '5px',
                                                                      mb: '10px',
                                                                      height:'auto',
                                                                      display: 'flex',
                                                                      alignItems: 'center',
                                                                      cursor: 'pointer',
                                                                      justifyContent:'space-between',
                                                                  }}
                                                                  key={index}
                                                                  // onClick={() => openModal(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
                                                                  onClick={() => {
                                                                      openModal(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`, '_blank')
                                                                  }}
                                                              >
                                                                  <Box
                                                                      sx={{
                                                                          display: 'flex',
                                                                          alignItems: 'center',
                                                                      }}
                                                                  >
                                                                      <PlayArrow
                                                                          sx={{
                                                                              fontSize: '1.3rem',
                                                                          }}
                                                                      />
                                                                      <Typography
                                                                          sx={{
                                                                              ml: '10px',
                                                                          }}
                                                                      >
                                                                          {form?.name}
                                                                      </Typography>
                                                                  </Box>
                                                                  <Box
                                                              sx={{
                                                                  display: 'flex',
                                                                  alignItems: 'center',
                                                              }}
                                                          >
                                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <AttachEmailIcon
                                                                  onClick={(e) =>  {e.stopPropagation()
                                                                   handleRowClick(form?.customer_id,form?.treatment_form_id)}}
                                                                      sx={{
                                                                          fontSize: '1.3rem',
                                                                      }}
                                                                  /> 
                                                              </div>
                                                                  {
                                                                      form?.is_submitted &&
                                                                     /* <CheckCircleOutlineIcon
                                                                          sx={{
                                                                              color: '#27AE60',
                                                                              fontSize: '1.8rem'
                                                                          }}
                                                                      />*/
                                                                      <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold" , ml:"5px"}}>{form?.submitted_time}</Typography>
              
                                                                  }
                                                              </Box>
                                                              </Box>
                                                          )) :
                                                          <Typography
                                                              sx={{
                                                                  fontFamily: "helvetica-lt-std-bold",
                                                                  textAlign: 'center',
                                                                  mt: '24px'
                                                              }}
                                                          >
                                                              Empty.
                                                          </Typography>
                                                  }
                                                  <Typography
                                                      sx={{
                                                          my: '25px',
                                                          fontFamily: "helvetica-lt-std-bold",
                                                      }}
                                                  >
                                                      Submitted Chart  Form:
                                                  </Typography>
                                                  {
                                                      allSubmittedForm?.chart_form?.length ?
                                                          allSubmittedForm?.chart_form?.map((form, index) => (
                                                              <Box
                                                                  sx={{
                                                                      width: '100%',
                                                                      background: '#EDF2F7',
                                                                      p: '5px 10px',
                                                                      borderRadius: '5px',
                                                                      mt: '5px',
                                                                      mb: '10px',
                                                                      height:'35px',
                                                                      display: 'flex',
                                                                      alignItems: 'center',
                                                                      cursor: 'pointer',
                                                                      justifyContent:'space-between',
                                                                  }}
                                                                  key={index}
                                                                  openModal
                                                                  onClick={() => {
                                                                      openModal(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`, '_blank')
                                                                  }}
                                                              >
                                                                  <Box
                                                                      sx={{
                                                                          display: 'flex',
                                                                          alignItems: 'center',
                                                                      }}
                                                                  >
                                                                      <PlayArrow
                                                                          sx={{
                                                                              fontSize: '1.3rem',
                                                                          }}
                                                                      />
                                                                      <Typography
                                                                          sx={{
                                                                              ml: '10px',
                                                                          }}
                                                                      >
                                                                          {form?.name}
                                                                      </Typography>
                                                                  </Box>
                                                                  { 
                                                                      form?.is_submitted &&
                                                                      /*<CheckCircleOutlineIcon
                                                                          sx={{
                                                                              color: '#27AE60',
                                                                              fontSize: '1.8rem'
                                                                          }}
                                                                      />*/
                                                                      <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold"}}>{form?.submitted_time}</Typography>
                                                                  }
                                                              </Box>
                                                          )) :
                                                          <Typography
                                                              sx={{
                                                                  fontFamily: "helvetica-lt-std-bold",
                                                                  textAlign: 'center',
                                                                  mt: '24px'
                                                              }}
                                                          >
                                                              Empty.
                                                          </Typography>
                                                  }
                                              </Box>
                </Box>}
                    {/* Image Modal */}
                    <CustomModal
                        customWidth={"1000px"}
                        mdWidthImage={'80%'}
                        open={modalImage !== null}
                        setOpen={() => setModalImage(null)}
                    >
                        <Box>
                            <Avatar  
                                src={modalImage}
                                sx={{
                                    cursor: 'pointer',
                                    height: '100%',
                                    width: '100%',
                                }}
                                variant="rounded"
                            />
                        </Box>
                    </CustomModal>
                <LinkModal open={isModalOpen} onClose={closeModal} linkUrl={selectedLinkUrl} />
          
            </Box>
        </Box>
        </Box>
    </Container>
</Modal>

     </>
    )
  }
export default CalenderNoteModal


//                                 <Box
//                                     key={index}
//                                     sx={{
//                                         py: '24px',
//                                         px: '16px',
//                                         borderTop: index > 0 ? '1px solid #9D9D9D' : 'unset',
//                                     }}>
//                                     <Typography sx={{ fontSize: '16px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
//                                         <Typography
//                                             as={'span'}
//                                         sx={{
//                                                 fontSize: '16px', fontFamily: "helvetica-world-bold",
//                                                 mr: '3px',
//                                                 fontWeight: 600,
//                                             }}
//                                         >
//                                             [ {note?.date} ]  {" "}
//                                             {note?.staff?.name}:
//                                         </Typography>
//                                         {note?.description.split(' ').map((word, idx) => {
//     const isImageFile = /^[0-9].*\.(jpeg|jpg|gif|png|jfif)$/.test(word); 

//     return (
//         <span  
//             key={idx} 
//             style={{
//                 cursor: isImageFile ? 'pointer' : 'default',
//                 color: isImageFile ? 'blue' : 'inherit', 
//                 textDecoration: isImageFile ? 'underline' : 'none',
//             }} 
//             onClick={() => {
//                 if (isImageFile) {
//                     const imageUrl = note?.attachments?.file; 
//                     //console.log("Image URL:", imageUrl);
//                     setModalImage(imageUrl); 
//                 }
//             }} 
//         >
//             {word}&nbsp; {/* Add a space here */}
//         </span>
//     );
// })}

//                                         {note?.booking_id && (
//                                             <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '8px' }}>
//                                                 Booking #
//                                                 <span style={{ marginLeft: '8px' }}>
//                                                     <AppointmentDetailsmodal booking_id={note?.booking_id} />
//                                                 </span>
//                                             </span>
//                                         )}
//                                     </Typography>
//                                 </Box>




//  add photo code
// {
//     galleryList?.length > 0 ?
//         galleryList.map((attachment) =>(
//             <Grid
//                 key={attachment?.id}
//                 sx={{cursor: 'pointer'}}
//                 onClick={() => !onHover && handleSelectedGallery(attachment)}
//             >
//                 <IconButton
//                     sx={{
//                         fontSize: "15px",
//                         position: "relative",
//                         p: "5px",
//                         zIndex: '1',
//                         background: "#EB5757",
//                         border: '1px solid #EB5757',
//                         m: '5px',
//                         left: "9rem",
//                         top: "0px",
//                         "&:hover": {
//                             border: '1px solid #EB5757',
//                             background: '#fff',
//                             "svg": {
//                                 color: '#EB5757'
//                             }
//                         }
//                     }}
//                     onMouseEnter={() => {
//                         setOnHover(true)
//                     }}
//                     onMouseLeave={() => {
//                         setOnHover(false)
//                     }}
//                     onClick={() => onHover && handleDelete(attachment?.id)}
//                 >
//                     <DeleteOutlineIcon sx={{color: '#fff', fontSize: '20px'}}/>
//                 </IconButton>
//                 <Box
//                     sx={{
//                         height: '185px',
//                         mt: "-41px",
//                         width: '185px',
//                         p: '10px',
//                         border: '1px solid #BDBDBD',
//                         borderRadius: '4px',
//                         // position: 'relative'
//                     }}
//                 >
//                     {
//                         attachment?.files?.length > 0 ?
//                             attachment?.files.map((file, index) => index < 2 && (
//                                 <>
                                 
//                                 <Avatar
//                                     key={index}
//                                     src={file?.file}
//                                     sx={{
//                                         height: attachment?.files?.length > 1 ? '145px' : '100%',
//                                         width: attachment?.files?.length > 1 ? '145px' : '100%',
//                                         position: "relative",
//                                         top: index === 1 ? "-128px" : '',
//                                         left: index === 1 ? "17px" : '',
//                                     }}
//                                     variant="rounded"
//                                 />
//                                 </>
                             
//                             ))
//                             :
//                             <Avatar
//                                 sx={{
//                                     height: '100%',
//                                     width: '100%',
//                                 }}
//                                 variant="rounded"
//                             />
//                     }
//                 </Box>
//                 <Box
//                     sx={{
//                         display:'flex',
//                         justifyContent:'space-between',
//                         alignItems:'center',
//                         mt: '10px',
//                     }}
//                 >
//                     <Typography
//                         sx={{
//                             fontSize: '14px',
//                             maxWidth: '185px',
//                             textTransform:'capitalize',
//                             fontFamily: 'helvetica-lt-std-bold',
//                         }}
//                     >
//                         {attachment?.tag?.tag_name}
//                     </Typography>

//                     {/*<Typography>*/}
//                     {/*    {moment(attachment?.created_at).format("YYYY-MM-DD")}*/}
//                     {/*</Typography>*/}
//                 </Box>
//             </Grid>
//         ))
//         :
//         <Grid xs={12} item>
//             <Typography sx={{textAlign: 'center'}}>None</Typography>
//         </Grid>
// }